import { bindAll } from 'lodash'

import {
  createErrorAction,
  createPayloadAction,
  getEnvironmentVariable,
} from '../../core/helpers'
import { Apollo } from '../../core/services'

const apolloService = {
  client: new Apollo({
    httpUri: `${getEnvironmentVariable('REACT_APP_HTTP_SERVER_URL')}/graphql`,
    subscriptionUri: `${getEnvironmentVariable(
      'REACT_APP_WEBSOCKET_SERVER_URL',
    )}/subscriptions`,
  }),

  async request({
    query,
    mutation,
    variables,
    dispatch,
    action: {
      START: startActionType,
      COMPLETE: completeActionType,
      FAIL: failActionType,
    },
    onSuccess,
  }) {
    dispatch(createPayloadAction(startActionType)(variables))

    try {
      const result = query
        ? await this.client.client.query({
            query,
            variables,
            fetchPolicy: 'no-cache',
          })
        : await this.client.client.mutate({
            mutation,
            variables,
            fetchPolicy: 'no-cache',
          })

      dispatch(
        createPayloadAction(completeActionType)({ ...result, variables }),
      )

      if (onSuccess) {
        onSuccess({ ...result, variables })
      }

      return result
    } catch (error) {
      dispatch(createErrorAction(failActionType)(error, variables))
      return error
    }
  },

  async query({
    query,
    variables,
    dispatch,
    action: {
      START: startActionType,
      COMPLETE: completeActionType,
      FAIL: failActionType,
    },
    onSuccess,
  }) {
    return this.request({
      query,
      variables,
      dispatch,
      action: {
        START: startActionType,
        COMPLETE: completeActionType,
        FAIL: failActionType,
      },
      onSuccess,
    })
  },

  async mutate({
    mutation,
    variables,
    dispatch,
    action: {
      START: startActionType,
      COMPLETE: completeActionType,
      FAIL: failActionType,
    },
    onSuccess,
  }) {
    return this.request({
      mutation,
      variables,
      dispatch,
      action: {
        START: startActionType,
        COMPLETE: completeActionType,
        FAIL: failActionType,
      },
      onSuccess,
    })
  },
}

export default bindAll(apolloService, ['query', 'mutate'])
